var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 71,
    viewBox: "0 0 40 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69531 35.1382C3.69531 36.6866 3.87699 38.1248 4.07515 39.6534C4.28996 41.3105 4.24669 43.0388 4.24669 44.7078C4.24669 47.8264 4.2899 50.9566 4.13029 54.069C3.87518 59.0437 3.80559 64.0062 3.80559 68.993",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14258 27.4189C3.14258 27.6149 3.17321 27.7007 3.25285 27.86",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8314 13.6431C37.0627 9.97056 35.8331 6.8359 33.1703 4.32106C30.9071 2.18359 28.4143 1.99054 25.4505 1.99054C21.4663 1.99054 18.5936 6.11868 18.0057 9.64565C16.8152 16.7889 15.6914 23.8841 15.6914 31.1221C15.6914 35.3448 15.9827 39.5416 15.9827 43.7133C15.9827 45.6055 16.5654 47.5413 16.5654 49.4102C16.5654 50.6789 16.4891 53.1363 17.0023 54.2654C17.4244 55.1939 17.4393 57.1793 17.4393 58.2144C17.4393 59.4767 17.4393 60.7391 17.4393 62.0015C17.4393 64.332 17.4393 66.6625 17.4393 68.993",
    stroke: "#1023DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35.2005C12.1797 35.2005 22.5123 35.4918 32.5881 35.4918",
    stroke: "#1023DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIf);
export default __webpack_public_path__ + "static/media/IF.1ba10a6ae25fb20deecd7cdbffc6d197.svg";
export { ForwardRef as ReactComponent };